import React from "react";
import NotAReceiptOverlay from './NotAReceiptOverlay';

const NotAReceiptOverlayContainer = ({ children }: { children: React.ReactNode }) => {
    const [backgroundImage, setBackgroundImage] = React.useState<string | undefined>(undefined);

    return (
        <div style={{ position: 'relative', backgroundImage, backgroundRepeat: 'repeat-y', backgroundSize: 'min(100%, 500px) auto' }}>
            {children}
            <div
                aria-hidden="true"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', visibility: 'hidden', pointerEvents: 'none' }}
            >
                <NotAReceiptOverlay onRender={setBackgroundImage} />
            </div>
        </div>
    );
};

export default NotAReceiptOverlayContainer;